import React from 'react';
import Gallery from '../components/Gallery';
import "./Style.css"
import BackToTopBtn from '../components/BackToTopBtn';
import { SpeedInsights } from "@vercel/speed-insights/react"
import Contact from './Contact';
import { Analytics } from "@vercel/analytics/react"
import Banner from '../components/Banner';

const Home: React.FC = () => {
    const paintingsAbstract = [
        { src: '/pictures/abstract1.jpeg', title: 'Împreună', price: '150', dimensions: '40x60 cm', availability: "1 disponibil" },
        { src: '/pictures/abstract2.jpeg', title: 'Împreună', price: '150', dimensions: '40x60 cm', availability: "1 disponibil" },
        { src: '/pictures/abstract3.jpeg', title: 'Copacul', price: '250 ', dimensions: '30x90 cm', availability: "vândut" },
        { src: '/pictures/abstract4.jpeg', title: 'Colors', price: '300', dimensions: '80x110 cm', availability: "vândut" },
        { src: '/pictures/abstract5.jpeg', title: 'Colors', price: '300', dimensions: '80x110 cm', availability: "vândut" },
        { src: '/pictures/aurora.jpeg', title: 'Aurora', price: '150', dimensions: '40x60 cm', availability: "vândut" },
        { src: '/pictures/munti2.jpeg', title: 'Munții', price: '300', dimensions: '50x70 cm', availability: "1 disponibil" },
        { src: '/pictures/munti1.jpeg', title: 'Munții', price: '300', dimensions: '50x70 cm', availability: "1 disponibil" },
    ];

    const paintingsFata = [
        { src: '/pictures/fata1.jpeg', title: 'În întuneric', price: "450", dimensions: "50x70 cm", availability: "vândut" },
        { src: '/pictures/fata2.jpeg', title: 'The lady in red', price: "500", dimensions: "30x90 cm", availability: "1 disponibil" },
        { src: '/pictures/fata3.jpeg', title: 'Salsa', price: "400", dimensions: "30x90 cm", availability: "vândut" },
        { src: '/pictures/fata4.jpeg', title: 'Balerina', price: "450", dimensions: "50x70 cm", availability: "1 disponibil" },
        { src: '/pictures/fata5.jpeg', title: 'Abstract face', price: "450", dimensions: "60x90 cm", availability: "1 disponibil" },
        { src: '/pictures/fata6.jpeg', title: 'Fata cu pălărie', price: "450", dimensions: "30x90 cm", availability: "1 disponibil" },
        { src: '/pictures/fata7.jpeg', title: 'Natural lady', price: "300", dimensions: "30x90 cm", availability: "vândut" },
        { src: '/pictures/fata8.jpeg', title: 'Abstract lady', price: "450", dimensions: "60x60 cm", availability: "vândut" },
        { src: '/pictures/fata9.jpeg', title: 'Yellow lady', price: "300", dimensions: "30x90 cm", availability: "vândut" },
        { src: '/pictures/fata10.jpeg', title: 'Getting ready', price: "200", dimensions: "20x35 cm", availability: "vândut" },
        { src: '/pictures/fata11.jpeg', title: 'În întuneric 2', price: "400", dimensions: "50x70 cm", availability: "vândut" },
        { src: '/pictures/fata12.jpeg', title: 'Ciubarul', price: "400", dimensions: "50x70 cm", availability: "vândut" },
        { src: '/pictures/fata13.jpeg', title: 'Fata cu vioara', price: "400", dimensions: "60x90 cm", availability: "vândut" },
        { src: '/pictures/fata14.jpeg', title: 'Plimbăreții', price: "250", dimensions: "30x50 cm", availability: "vândut" },
        { src: '/pictures/fata15.jpeg', title: 'Africans', price: "800", dimensions: "2 - 50x70 cm & 1 - 30x90 cm", availability: "vândut" },
    ];

    const paintingsPingu = [
        { src: '/pictures/pingu1.jpeg', title: 'Pingu', price: "500", dimensions: "60x90 cm", availability: "1 disponibil" },
        { src: '/pictures/pingu2.jpeg', title: 'Pingu', price: "500", dimensions: "60x90 cm", availability: "1 disponibil" },
    ];

    const paintingsWall = [
        { src: '/pictures/wall1.jpeg', title: 'Arta pe pereti', price: "", dimensions: "custom", availability: "detalii la telefon" },
    ];
    

    const paintingsFlower = [
        { src: '/pictures/flori1.jpeg', title: 'Toporași', price: "200", dimensions: "50x50 cm", availability: "1 disponibil" },
        { src: '/pictures/flori2.jpeg', title: 'Perdea de flori', price: "200", dimensions: "40x60 cm", availability: "1 disponibil" },
        { src: '/pictures/flori3.jpeg', title: 'Păpădie', price: "200", dimensions: "40x60 cm", availability: "1 disponibil" },
        { src: '/pictures/flori4.jpeg', title: 'Orhidee', price: "200", dimensions: "50x50 cm", availability: "1 disponibil" },
        { src: '/pictures/flori5.jpeg', title: 'Copacul cu flori', price: "200", dimensions: "50x50 cm", availability: "vândut" },
        { src: '/pictures/flori6.jpeg', title: 'Orhidee pe roșu', price: "200", dimensions: "50x50 cm", availability: "vândut" },
        { src: '/pictures/flori7.jpeg', title: 'Buchetul de flori', price: "100", dimensions: "20x30 cm", availability: "vândut" },
    ];

    const paintingsMoon = [
        { src: '/pictures/luna3.jpeg', title: 'Luna (luminată, cu suport pentru floare)', price: '550', dimensions: '55x65 cm', availability: "1 disponibil" },
        // { src: '/pictures/luna6.jpeg', title: 'Luna (luminată, fără suport pentru floare)', price: '500', dimensions: '55x65 cm', availability: "2 disponibile"},
        { src: '/pictures/luna7.jpeg', title: 'Semilună', price: '500', dimensions: '55x55 cm', availability: "1 disponibil" },
        { src: '/pictures/luna1.jpeg', title: 'Luna (luminată, fără suport pentru floare)', price: '600', dimensions: '80x85 cm', availability: "vândut" },
        { src: '/pictures/luna2.jpeg', title: 'Luna (luminată, cu suport pentru floare)', price: '650', dimensions: '80x90 cm', availability: "vândut" },
        { src: '/pictures/luna4.jpeg', title: 'Luna (luminată, cu suport pentru floare)', price: '550', dimensions: '55x65 cm', availability: "1 disponibile" },
        { src: '/pictures/luna5.jpeg', title: 'Luna (luminată, cu suport pentru floare)', price: '550', dimensions: '55x65 cm', availability: "1 disponibile" }
    ];

    const paintingsPouring = [
        { src: '/pictures/pouring1.jpeg', title: 'Tablou 3', price: "500", dimensions: "70x110 cm", availability: "vândut" },
        { src: '/pictures/pouring2.jpeg', title: 'Tablou 3', price: "500", dimensions: "70x110 cm", availability: "vândut" },
    ];

    return (
        <div>
            <Analytics />
            <BackToTopBtn />
            <Banner />
            <div className="text-container">

                <div id="winter">
                    <hr className="custom-line" />
                    <p><b>Editia de iarna</b></p>
                    <Gallery paintings={paintingsPingu} />
                </div>

                <div id="wall">
                    <hr className="custom-line" />
                    <p><b>Arta pe pereti</b></p>
                    <Gallery paintings={paintingsWall} />
                </div>

                <div id="moon">
                    <p><b> Luna / The Moon</b> </p>
                    <p>Aceste modele reprezintă tablouri sculptate, care capătă o frumusețe deosebită în timpul serii și nopții, când jocul luminii evidențiază cu rafinament formele și detaliile acestora. Fiecare model este unic, variind atât în dimensiuni, iar unele dintre ele sunt prevăzute cu suporturi delicate pentru flori, adăugând un plus de eleganță.</p>
                    <Gallery paintings={paintingsMoon} />
                </div>
                <div id="abstract">
                    <hr className="custom-line" />
                    <p><b>Tablouri abstracte</b> </p>
                    <p>Tablouri pictate în acrilic, modele abstracte.</p>
                    <Gallery paintings={paintingsAbstract} />
                </div>

                <div id="people">
                    <hr className="custom-line" />
                    <p><b>Chipuri și Povesti</b></p>
                    <Gallery paintings={paintingsFata} />
                </div>

                <div id="pouring">
                    <hr className="custom-line" />
                    <p><b>Tablouri pouring Art</b></p>
                    <Gallery paintings={paintingsPouring} />
                </div>

                <div id="flowers">
                    <hr className="custom-line" />
                    <p><b>Tablouri cu flori</b></p>
                    <Gallery paintings={paintingsFlower} />
                </div>                

                <Contact />
            </div>
            <SpeedInsights />
        </div>
    );
};

export default Home;
